import axios from "axios";

export const fetchGetTaskCounterDetail = async (id: string) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.get(`${baseTaskUrl}/TaskCounterTemplate/${id}`);
};
